import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "autoSpan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StockImageTag = _resolveComponent("StockImageTag")!

  return (_ctx.stock)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "item profile",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onStockClicked && _ctx.onStockClicked(...args)))
      }, [
        (_openBlock(), _createBlock(_component_StockImageTag, {
          class: "small",
          key: _ctx.stock.symbol,
          stockData: _ctx.stock,
          imgUrl: _ctx.stock.logoUrl,
          symbol: _ctx.stock.symbol,
          market: _ctx.stock.type,
          stockId: _ctx.stock.stockId,
          disableRouting: true
        }, null, 8, ["stockData", "imgUrl", "symbol", "market", "stockId"])),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.stock.symbol) + " ", 1),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.stock.name), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}